import React from 'react'

import FirebaseContext from './FirebaseContext'

// This function takes a component...
export default function withFirebase(Component) {
  // ...and returns another component...
  return function FirebasedComponent(props) {
    // ... and renders the wrapped component with the context firebase!
    // Notice that we pass through any additional props as well
    return (
      <FirebaseContext.Consumer>
        {firebase => {
          const storage = () => firebase.storage()
          const auth = () => firebase.auth()
          return <Component {...props} firebase={{ storage, auth }} />
        }}
      </FirebaseContext.Consumer>
    )
  }
}
